import React, { useState } from "react";
import logo from "../../../../assets/images/Logo-no-bg.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./asideNav.css";
import { LuLayoutDashboard } from "react-icons/lu";
import { IoTicket } from "react-icons/io5";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { MdOutlineCallReceived } from "react-icons/md";
import { LuPrinter } from "react-icons/lu";
import { MdOutlinePayments } from "react-icons/md";
import { LuScanLine } from "react-icons/lu";
import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
import ToggleButton from "../../../sharedComponents/navbar/sub_component/ToggleButton";
import { toast } from "react-toastify";

const navClass = ({ isActive }) =>
  `aside-nav-link flex lg:w-full items-center lg:py-3 pl-3 gap-3 ${
    isActive ? "active" : ""
  }`;

const AsideNav = () => {
  const localdata = localStorage.getItem("sundorbonBookingUserDetails");
  const Name = JSON.parse(localdata)?.Name || "";
  const Email = JSON.parse(localdata)?.Email || "";

  const NavBarhandle = () => {
    setToggleBtnChecked(false);
    setShowAside(false);
  };

  const Routes = (
    <>
      <NavLink onClick={NavBarhandle} end className={navClass} to="/agent-dashboard">
        <LuLayoutDashboard />
        Dashboard
      </NavLink>

      <NavLink onClick={NavBarhandle} className={navClass} to="requisition">
        <MdOutlineAddCircleOutline />
        Requisition
      </NavLink>

      <NavLink onClick={NavBarhandle} className={navClass} to="receive">
        <MdOutlineCallReceived />
        Receive
      </NavLink>

      <NavLink onClick={NavBarhandle} className={navClass} to="payment">
        <MdOutlinePayments />
        Payment
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className={navClass}
        to="parcel-status-scan"
      >
        <LuScanLine />
        Parcel Status Scan
      </NavLink>

      <NavLink onClick={NavBarhandle} className={navClass} to="print-barcode">
        <LuPrinter />
        Print Barcode
      </NavLink>

      <Link
        onClick={NavBarhandle}
        className="aside-nav-link flex lg:w-full items-center lg:py-3 pl-3 gap-3"
        to="/agency-bookings"
      >
        <IoTicket />
        Add Booking
      </Link>
    </>
  );

  const [showAside, setShowAside] = useState(false);
  const [toggleBtnChecked, setToggleBtnChecked] = useState(false);
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
    setToggleBtnChecked(e.target.checked);
  };

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success("Logout Successfull", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    localStorage.removeItem("sundorbonBookingUserDetails");
    localStorage.removeItem("token");
    move("/");
  };

  return (
    <div className="user-aside-premium xl:w-[17%] lg:w-[25%] lg:flex z-30 flex-col justify-start items-start lg:gap-10 lg:pb-11 overflow-hidden lg:pt-10 w-full lg:h-[93vh] lg:rounded-[24px] lg:sticky top-0 lg:top-[3%] lg:left-2 xl:left-3 text-white">
      <div className="relative hidden lg:w-full lg:flex justify-center items-center flex-row lg:flex-col">
        <Link to="/" onClick={() => setShowAside(false)}>
          <img
            className="w-full max-w-[200px] px-3 object-contain lg:inline-block hidden xl:h-[120px] lg:h-[90px]"
            src={logo}
            alt="logo"
          />
        </Link>
        <div className="lg:mt-8 hidden text-left lg:block w-full px-4">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-3.5 backdrop-blur-sm">
            <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-orange-300/90">
              Agent
            </p>
            <h1 className="text-base font-bold truncate text-white mt-1">
              {Name || "Agent"}
            </h1>
            <h2 className="text-xs font-medium mt-0.5 truncate text-white/65">
              {Email}
            </h2>
          </div>
        </div>
      </div>

      <ul className="w-full hidden scrollbar lg:h-[70%] lg:overflow-y-auto lg:pr-4 lg:pl-3 lg:flex flex-col gap-y-2 xl:text-base text-base text-white">
        {Routes}
      </ul>

      <div className="lg:hidden block z-50 text-white w-full">
        <div className="relative z-50 flex items-center justify-between pr-2 bg-[#424242]">
          <ToggleButton
            value={toggleBtnChecked}
            showAside={showAside}
            eventHandle={ToggleEventHandler}
          />
          <div className="flex items-center gap-2 pr-2">
            <Link to="/agency-bookings" className="text-white px-3 py-2 text-sm rounded-md">
              Booking
            </Link>
            {GetLocalStorageUserId() ? (
              <button onClick={logoutHandle} className="text-white px-3 py-2 text-sm rounded-md">
                Logout
              </button>
            ) : (
              <Link to="/login" className="text-white px-3 py-2 text-sm rounded-md">
                Login
              </Link>
            )}
          </div>
        </div>

        <div
          className={`w-full bg-[#424242] duration-300 absolute z-40 ${
            showAside ? "translate-y-0" : "-translate-y-[2000px]"
          }`}
        >
          <ul className="flex flex-col pb-4 gap-y-3 justify-center text-[18px] font-normal items-start pl-[40px]">
            {Routes}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AsideNav;
